import { useLiveQuery } from "dexie-react-hooks";
import { draftDB } from "./db";

export function useLatestLocalDraftId(projectId: number) {
  return useLiveQuery(async () => {
    const drafts = await draftDB.dailyLogDrafts.where("project_id").equals(projectId).sortBy("updated_at");
    return drafts[drafts.length - 1]?.draft_id;
  }, [projectId]);
}
